<template>
  <v-app>
    <TheSideBar v-if="isLogged && isAdmin"/>
    <TheTopBar v-if="isLogged && !isAdmin"/>
    <v-main id="content" class="animated-background">
      <AnimatedBackground v-if="showBackground"/>
      <transition name="fade" mode="out-in">
        <router-view :key="$route.fullPath"/>
      </transition>
      <TheContactModal v-if="isLogged && !isAdmin" />
      <TheNotifier />
    </v-main>
    <TheFooter />
  </v-app>
</template>

<script>
  import TheSideBar from '@/components/Navigation/TheSideBar'
  import TheTopBar from '@/components/Navigation/TheTopBar'
  import TheFooter from '@/components/Navigation/TheFooter'
  import TheContactModal from '@/components/Contact/TheContactModal'
  import TheNotifier from '@/components/Notification/TheNotifier'
  import AnimatedBackground from '@/components/Utils/AnimatedBackground'
  import { mapActions, mapGetters, mapState } from 'vuex'
  import routeNames from '@/router/routeNames'

  export default {
    components: {
      TheSideBar,
      TheTopBar,
      TheFooter,
      TheContactModal,
      TheNotifier,
      AnimatedBackground
    },
    computed: {
      ...mapState('auth', [
        'isLogged',
        'user',
      ]),
      ...mapGetters('auth', [
        'isAdmin'
      ]),
      showBackground () {
        return this.$route.name === routeNames.login
      }
    },
    watch: {
      user (user) {
        user && !this.isAdmin ? this.apply(user.mall.color) : this.restore()
      }
    },
    methods: {
      ...mapActions('theme', [
        'apply',
        'restore'
      ])
    }
  }
</script>

<style>
#content {
  background-color:#eeeeee!important;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
